import React, { useEffect, useState } from 'react';
import {
	Grid,
	Box,
	FormControlLabel,
	useMediaQuery,
	Radio,
	Checkbox,
	Tooltip,
	IconButton
} from '@material-ui/core';
import { WEEKDAYS, WEEKEND_GUIDE_TOOLTIP } from 'constants/constant';
import reportSettingStyles from '../ReportSettings.style';
import PropTypes from 'prop-types';
import { deepClone } from 'helper/helper';
import CloseIcon from '@material-ui/icons/Close';
function Weekdays(props) {
	const { setWeeks, weeks, isOnlySingleDayAllowed } = props;
	const isSmallScreen = useMediaQuery('(max-width:768px)');
	const classes = reportSettingStyles({ isSmallScreen });

	const [satTooltipOpen, setSatTooltipOpen] = useState(false);
	const [sunTooltipOpen, setSunTooltipOpen] = useState(false);

	useEffect(() => {
		const updatedWeek = weeks;
		if (isOnlySingleDayAllowed) {
			const selectedDay = Object.keys(updatedWeek)
				.map((day) => updatedWeek[day])
				.filter((isSelected) => isSelected === true);
			if (selectedDay.length > 0) {
				return;
			}
		}
		const day = new Date().toLocaleString('en-us', { weekday: 'short' });
		const selectedDay = Object.keys(updatedWeek)
			.map((day) => updatedWeek[day])
			.filter((isSelected) => isSelected === true);
		if (selectedDay.length === 0) {
			updatedWeek[day] = true;
		}
		setWeeks({ ...updatedWeek });
	}, []);

	const handleChange = (event, label) => {
		handleTooltipClose();
		const obj = deepClone(weeks);
		if (isOnlySingleDayAllowed) {
			Object.keys(obj).forEach((o) => (obj[o] = false));
			if (label === 'Sat') {
				setSatTooltipOpen(true);
			} else if (label === 'Sun') {
				setSunTooltipOpen(true);
			}
		}
		setWeeks({ ...obj, [event.target.name]: event.target.checked });
	};

	const handleTooltipClose = () => {
		setSatTooltipOpen(false);
		setSunTooltipOpen(false);
	};

	const shouldTooltipOpen = (label) => {
		if (label === 'Sat') {
			return satTooltipOpen;
		} else if (label === 'Sun') {
			return sunTooltipOpen;
		}
		return false;
	};

	const getRadioBtnsForWeekday = (item) => {
		return (
			<Tooltip
				classes={{ arrow: classes.arrow, tooltip: classes.radioWeekendTooltip }}
				arrow
				placement="bottom-start"
				title={
					<>
						{WEEKEND_GUIDE_TOOLTIP}
						<IconButton
							onClick={handleTooltipClose}
							style={{ height: '16px', width: '16px' }}
							id="close-tooltip">
							<CloseIcon style={{ fontSize: '16px' }} />
						</IconButton>
					</>
				}
				PopperProps={{
					disablePortal: false
				}}
				onClose={handleTooltipClose}
				open={shouldTooltipOpen(item.label)}
				disableFocusListener
				disableHoverListener
				disableTouchListener>
				<Radio
					id={item.label}
					color="primary"
					checked={!!weeks[item.label]}
					onChange={(e) => handleChange(e, item.label)}
					name={item.label}
				/>
			</Tooltip>
		);
	};

	return (
		<Grid container alignItems="center" justifyContent="center">
			<Box id="weekdays-select">
				{WEEKDAYS.map((item) => {
					return (
						<FormControlLabel
							className={classes.weeks}
							key={item.label}
							control={
								isOnlySingleDayAllowed ? (
									getRadioBtnsForWeekday(item)
								) : (
									<Checkbox
										id={item.label}
										color="primary"
										checked={!!weeks[item.label]}
										onChange={handleChange}
										name={item.label}
									/>
								)
							}
							label={item.label}
						/>
					);
				})}
			</Box>
		</Grid>
	);
}

Weekdays.propTypes = {
	setWeeks: PropTypes.func.isRequired
};

export default Weekdays;
